// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "simsandbox/v1/simsandbox.proto" (package "simsandbox.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal RPCs for running a simulation sandbox against a machine part.
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { SimSandboxService } from "./simsandbox";
import type { GetSimSandboxStatsResponse } from "./simsandbox";
import type { GetSimSandboxStatsRequest } from "./simsandbox";
import type { GetSimSandboxPriceResponse } from "./simsandbox";
import type { GetSimSandboxPriceRequest } from "./simsandbox";
import type { GetMachineSimSandboxesResponse } from "./simsandbox";
import type { GetMachineSimSandboxesRequest } from "./simsandbox";
import type { GetSimSandboxStatusResponse } from "./simsandbox";
import type { GetSimSandboxStatusRequest } from "./simsandbox";
import type { DestroySimSandboxResponse } from "./simsandbox";
import type { DestroySimSandboxRequest } from "./simsandbox";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CreateSimSandboxResponse } from "./simsandbox";
import type { CreateSimSandboxRequest } from "./simsandbox";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * SimSandboxService creates and destroys ephemeral simulation sandboxes bound
 * to a single machine part.
 *
 * @generated from protobuf service simsandbox.v1.SimSandboxService
 */
export interface ISimSandboxServiceClient {
    /**
     * Creates a new sandbox bound to the given part and returns its identifier.
     * Fails while the part already has a pending, provisioning, or started sandbox.
     *
     * @generated from protobuf rpc: CreateSimSandbox(simsandbox.v1.CreateSimSandboxRequest) returns (simsandbox.v1.CreateSimSandboxResponse);
     */
    createSimSandbox(input: CreateSimSandboxRequest, options?: RpcOptions): UnaryCall<CreateSimSandboxRequest, CreateSimSandboxResponse>;
    /**
     * Destroys a sandbox created by the caller.
     *
     * @generated from protobuf rpc: DestroySimSandbox(simsandbox.v1.DestroySimSandboxRequest) returns (simsandbox.v1.DestroySimSandboxResponse);
     */
    destroySimSandbox(input: DestroySimSandboxRequest, options?: RpcOptions): UnaryCall<DestroySimSandboxRequest, DestroySimSandboxResponse>;
    /**
     * Reports a sandbox's recorded state.
     *
     * @generated from protobuf rpc: GetSimSandboxStatus(simsandbox.v1.GetSimSandboxStatusRequest) returns (simsandbox.v1.GetSimSandboxStatusResponse);
     */
    getSimSandboxStatus(input: GetSimSandboxStatusRequest, options?: RpcOptions): UnaryCall<GetSimSandboxStatusRequest, GetSimSandboxStatusResponse>;
    /**
     * Returns the most recently started sandbox of each of a machine's parts, if
     * any, as last recorded. Requires only read access to the machine.
     *
     * @generated from protobuf rpc: GetMachineSimSandboxes(simsandbox.v1.GetMachineSimSandboxesRequest) returns (simsandbox.v1.GetMachineSimSandboxesResponse);
     */
    getMachineSimSandboxes(input: GetMachineSimSandboxesRequest, options?: RpcOptions): UnaryCall<GetMachineSimSandboxesRequest, GetMachineSimSandboxesResponse>;
    /**
     * Returns what a minute of a sandbox on the given part costs, per the
     * billing tier of the org it would bill.
     *
     * @generated from protobuf rpc: GetSimSandboxPrice(simsandbox.v1.GetSimSandboxPriceRequest) returns (simsandbox.v1.GetSimSandboxPriceResponse);
     */
    getSimSandboxPrice(input: GetSimSandboxPriceRequest, options?: RpcOptions): UnaryCall<GetSimSandboxPriceRequest, GetSimSandboxPriceResponse>;
    /**
     * Returns aggregate usage, placement, and cost stats over the sandboxes launched inside a time
     * window, for the internal sim sandbox stats dashboard. Restricted to Viam employees.
     *
     * @generated from protobuf rpc: GetSimSandboxStats(simsandbox.v1.GetSimSandboxStatsRequest) returns (simsandbox.v1.GetSimSandboxStatsResponse);
     */
    getSimSandboxStats(input: GetSimSandboxStatsRequest, options?: RpcOptions): UnaryCall<GetSimSandboxStatsRequest, GetSimSandboxStatsResponse>;
}
/**
 * SimSandboxService creates and destroys ephemeral simulation sandboxes bound
 * to a single machine part.
 *
 * @generated from protobuf service simsandbox.v1.SimSandboxService
 */
export class SimSandboxServiceClient implements ISimSandboxServiceClient, ServiceInfo {
    typeName = SimSandboxService.typeName;
    methods = SimSandboxService.methods;
    options = SimSandboxService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Creates a new sandbox bound to the given part and returns its identifier.
     * Fails while the part already has a pending, provisioning, or started sandbox.
     *
     * @generated from protobuf rpc: CreateSimSandbox(simsandbox.v1.CreateSimSandboxRequest) returns (simsandbox.v1.CreateSimSandboxResponse);
     */
    createSimSandbox(input: CreateSimSandboxRequest, options?: RpcOptions): UnaryCall<CreateSimSandboxRequest, CreateSimSandboxResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateSimSandboxRequest, CreateSimSandboxResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Destroys a sandbox created by the caller.
     *
     * @generated from protobuf rpc: DestroySimSandbox(simsandbox.v1.DestroySimSandboxRequest) returns (simsandbox.v1.DestroySimSandboxResponse);
     */
    destroySimSandbox(input: DestroySimSandboxRequest, options?: RpcOptions): UnaryCall<DestroySimSandboxRequest, DestroySimSandboxResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<DestroySimSandboxRequest, DestroySimSandboxResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Reports a sandbox's recorded state.
     *
     * @generated from protobuf rpc: GetSimSandboxStatus(simsandbox.v1.GetSimSandboxStatusRequest) returns (simsandbox.v1.GetSimSandboxStatusResponse);
     */
    getSimSandboxStatus(input: GetSimSandboxStatusRequest, options?: RpcOptions): UnaryCall<GetSimSandboxStatusRequest, GetSimSandboxStatusResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSimSandboxStatusRequest, GetSimSandboxStatusResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Returns the most recently started sandbox of each of a machine's parts, if
     * any, as last recorded. Requires only read access to the machine.
     *
     * @generated from protobuf rpc: GetMachineSimSandboxes(simsandbox.v1.GetMachineSimSandboxesRequest) returns (simsandbox.v1.GetMachineSimSandboxesResponse);
     */
    getMachineSimSandboxes(input: GetMachineSimSandboxesRequest, options?: RpcOptions): UnaryCall<GetMachineSimSandboxesRequest, GetMachineSimSandboxesResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetMachineSimSandboxesRequest, GetMachineSimSandboxesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Returns what a minute of a sandbox on the given part costs, per the
     * billing tier of the org it would bill.
     *
     * @generated from protobuf rpc: GetSimSandboxPrice(simsandbox.v1.GetSimSandboxPriceRequest) returns (simsandbox.v1.GetSimSandboxPriceResponse);
     */
    getSimSandboxPrice(input: GetSimSandboxPriceRequest, options?: RpcOptions): UnaryCall<GetSimSandboxPriceRequest, GetSimSandboxPriceResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSimSandboxPriceRequest, GetSimSandboxPriceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Returns aggregate usage, placement, and cost stats over the sandboxes launched inside a time
     * window, for the internal sim sandbox stats dashboard. Restricted to Viam employees.
     *
     * @generated from protobuf rpc: GetSimSandboxStats(simsandbox.v1.GetSimSandboxStatsRequest) returns (simsandbox.v1.GetSimSandboxStatsResponse);
     */
    getSimSandboxStats(input: GetSimSandboxStatsRequest, options?: RpcOptions): UnaryCall<GetSimSandboxStatsRequest, GetSimSandboxStatsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSimSandboxStatsRequest, GetSimSandboxStatsResponse>("unary", this._transport, method, opt, input);
    }
}
